import saveReportingOptionHelper from '../mutators/saveReportingOptionMutator';
import saveReportJunkService from '../services/saveReportJunkService';

export default async function saveReportingOption() {
    saveReportingOptionHelper();

    // Save reportJunkSelected && checkForReportJunkDialog service call
    await saveReportJunkService();
}
